import HttpClientToken from '../../services/HttpClientToken';

import { defaultTipoAcuerdo, TipoAcuerdoProps } from '../../interfaces/catalogos/TipoAcuerdoInterface';

export const TipoAcuerdo = () => {

    return new Promise<TipoAcuerdoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoAcuerdo/', token)
            .then( ({ data } : { data : TipoAcuerdoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerTipoAcuerdo = () => {

    return new Promise<TipoAcuerdoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoAcuerdo/ObtenerTipoAcuerdo', token)
            .then( ({ data } : { data : TipoAcuerdoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarTipoAcuerdo = ( params: TipoAcuerdoProps ) => {

    return new Promise<TipoAcuerdoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoAcuerdo/Actualizar', params, token)
            .then( ({ data } : { data : TipoAcuerdoProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoAcuerdo } );
            });

        }

    });

}

export const AgregarTipoAcuerdo = ( params: TipoAcuerdoProps ) => {

    return new Promise<TipoAcuerdoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoAcuerdo/Agregar', params, token)
            .then( ({ data } : { data : TipoAcuerdoProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoAcuerdo } );
            });

        }

    });

}
